export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS'
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js